import * as React from 'react';
// import * as ReactDOM from 'react-dom';
import { createRoot } from 'react-dom/client'; // Import createRoot
import { App } from './App';
import { BrowserRouter, HashRouter } from 'react-router-dom';
//import './index.css';

// ReactDOM.render(
// 
// 	<HashRouter>
// 		<App />
// 	</HashRouter>
// 	
// 	,
// 	document.getElementById('root')
// );

const container = document.getElementById('root');
if (container) {
  const root = createRoot(container); // Create a root.
  root.render( // Render the app using the new root.
    <React.StrictMode>
      <HashRouter>
        <App />
      </HashRouter>
    </React.StrictMode>
  );
}
